/* Neutralize dead links rendered by third-party widgets (e.g. Judge.me
   review cards whose product mapping is missing render href="null",
   which navigates to /null and 404s). */
(function () {
  var BAD = 'a[href="null"], a[href="undefined"], a[href="#null"]';

  // Safety net: block navigation even if a bad link appears later.
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest(BAD);
    if (a) e.preventDefault();
  }, true);

  // Cosmetic: strip the href so the card doesn't show a pointer cursor.
  // Also give Judge.me review photos an alt attribute (the widget omits it).
  function sweep() {
    document.querySelectorAll(BAD).forEach(function (a) {
      a.removeAttribute('href');
      a.style.cursor = 'default';
    });
    document.querySelectorAll('[class*="jdgm"] img:not([alt])').forEach(function (img) {
      var card = img.closest('[class*="jdgm-"]');
      var name = card ? card.querySelector('.jdgm-rev__prod-link, [class*="prod-name"]') : null;
      img.setAttribute('alt', name && name.textContent.trim()
        ? 'Customer photo - ' + name.textContent.trim().slice(0, 80)
        : 'Customer review photo');
    });
  }
  document.addEventListener('DOMContentLoaded', sweep);
  // Judge.me carousel renders async after load — re-sweep a few times.
  [1500, 3500, 7000].forEach(function (ms) { setTimeout(sweep, ms); });
})();
